import React from "react";
import U3121BillingSummaryDetailDlgFooter from "./U3121BillingSummaryDetailDlgFooter";

export interface U3121BillingSummaryDetailDlgBodyProps {
  onClose: () => void;
  children: React.ReactNode;
}

/**
 * Corps des dialogues détail sommaire facturation : pied Fermer toujours visible,
 * zone centrale seule scrollable (tableau à l’intérieur).
 */
const U3121BillingSummaryDetailDlgBody: React.FC<U3121BillingSummaryDetailDlgBodyProps> = ({ onClose, children }) => (
  <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
    <section className="flex min-h-0 flex-1 flex-col overflow-hidden px-6 pb-2 pt-2">{children}</section>
    <U3121BillingSummaryDetailDlgFooter onClose={onClose} />
  </div>
);

export default U3121BillingSummaryDetailDlgBody;
